import React from "react";
import {
	Text,
	MediaQuery,
	Image,
	Button,
	Container,
	Table,
	NativeSelect,
} from "@mantine/core";
import usermangementTable from "../../API/usermangementTable";
import {
	showSuccessNotification,
	showErrorNotification,
} from "../../utils/Notifications";
import { IconChevronDown } from "@tabler/icons";
import { useModals } from "@mantine/modals";
import tableuser from "../../static/svg/table-user.svg";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import deleteUser from "../../API/deleteUser";
import editUser from "../../API/editUser";
const TeamManagement = ({ setLoading }) => {
	const user = useSelector((state) => state.userInformationReducer.users);
	const obj = { UserId: user?.AccountId };
	const [editmode, setEditmode] = useState(false);
	const [saveId, SetSaveId] = useState("");
	const [tableData, setTableData] = useState();
	const modals = useModals();
	const elements = [
		{
			name: `${user?.FirstName} ${user?.LastName}`,
			AuthValue: user?.AuthValue,
			AccessLevel: "Creator",
		},
	];
	const openDeleteModal = (email) => {
		modals.openConfirmModal({
			title: "Please confirm your action",
			centered: true,
			styles: {
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			},
			children: (
				<Text size="sm">
					Are you sure you want to delete this experience?
				</Text>
			),
			labels: { confirm: "Delete", cancel: "Cancel" },
			confirmProps: { color: "red" },
			onConfirm: () => {
				setLoading(true);
				handleDelete(email);
			},
		});
	};
	const handleEdit = async (id) => {
		SetSaveId(id);
		setEditmode(true);
	};
	const refresh = async () => {
		const result = await usermangementTable(obj);
		setTableData(result);
	};
	const handleDelete = async (email) => {
		const result = await deleteUser(email);
		setLoading(false);
		if (result) {
			showSuccessNotification("Delete Successfuly");
		} else {
			showErrorNotification("Error");
		}
		refresh();
	};
	const handleSave = async (id) => {
		let role = document.getElementById("role:" + id).value;
		if (role === "Admin") {
			role = { RoleId: 2 };
		}
		if (role === "Viewer") {
			role = { RoleId: 4 };
		}
		if (role === "Creator") {
			role = { RoleId: 3 };
		}
		const result = await editUser(id, role);
		if (result === 1) {
			setEditmode(false);
			showSuccessNotification("update Successfuly");
			getTeamdetails(obj);
		} else {
			showErrorNotification("Error");
		}
	};
	const getTeamdetails = async (obj) => {
		const result = await usermangementTable(obj);
		setTableData(result);
	};
	const rows = tableData?.map((element) => (
		<>
			{element.UserId !== user?.UserId && element.AuthValue && (
				<tr
					style={{ borderBottom: "1px solid #373A40" }}
					key={element.name}
				>
					<MediaQuery
						smallerThan="sm"
						styles={{ width: "200px", marginTop: "0px" }}
					>
						<td
							style={{
								display: "flex",
								textAlign: "center",
								color: "#FFFFFF",
								fontSize: "70%",
								border: "none",
							}}
						>
							<div>
								<Image src={tableuser} pr={10} fit="contain" />
							</div>
							<div style={{ marginTop: "12px" }}>
								{" "}
								{element.name}
							</div>
						</td>
					</MediaQuery>
					<td
						style={{
							color: "#FFFFFF",
							fontSize: "70%",
							border: "none",
						}}
					>
						{element.AuthValue}
					</td>
					{editmode === true && saveId === element.UserId ? (
						<td
							style={{
								color: "#FFFFFF",
								fontSize: "100%",
								border: "none",
							}}
						>
							<NativeSelect
								className="nativeSelect"
								placeholder="Admin"
								data={["Admin", "Viewer", "Creator"]}
								styles={{
									input: {
										background: "#040F1F",
										color: "white",
									},
									root: {
										color: "white",
										borderRadius: "7px",
										border: "2px solid #2C2E33",
									},
								}}
								rightSection={<IconChevronDown size={14} />}
								rightSectionWidth={40}
								id={"role:" + element.UserId}
							/>
						</td>
					) : (
						<td
							style={{
								color: "#FFFFFF",
								fontSize: "70%",
								border: "none",
							}}
						>
							{element.RoleId === 2
								? "Admin"
								: element.RoleId === 3
								? "Creator"
								: element.RoleId === 4
								? "Viewer"
								: null}
						</td>
					)}
					<td style={{ float: "right", border: "none" }}>
						<MediaQuery
							smallerThan="sm"
							styles={{ marginTop: "0px", display: "flex" }}
						>
							<div>
								{editmode === true &&
								saveId === element.UserId ? (
									<Button
										size="xs"
										style={{
											color: "black",
											fontSize: "70%",
											marginRight: "10px",
										}}
										sx={{
											"&[editmode]": {
												display: "none",
											},
										}}
										onClick={() =>
											handleSave(element.UserId)
										}
									>
										save
									</Button>
								) : (
									<Button
										size="xs"
										style={{
											color: "black",
											fontSize: "70%",
											marginRight: "10px",
										}}
										onClick={() =>
											handleEdit(element.UserId)
										}
									>
										Edit
									</Button>
								)}
								<Button
									type="button"
									size="xs"
									style={{
										color: "black",
										fontSize: "70%",
									}}
									onClick={() => {
										openDeleteModal(element.AuthValue);
									}}
								>
									Delete
								</Button>
							</div>
						</MediaQuery>
					</td>
				</tr>
			)}
		</>
	));
	const ownerRow = elements?.map((element) => (
		<>
			<tr
				style={{ borderBottom: "1px solid #373A40" }}
				key={element.name}
			>
				<MediaQuery
					smallerThan="sm"
					styles={{ width: "200px", marginTop: "0px" }}
				>
					<td
						style={{
							display: "flex",
							textAlign: "center",
							color: "#FFFFFF",
							fontSize: "70%",
							border: "none",
						}}
					>
						<div>
							<Image src={tableuser} pr={10} fit="contain" />
						</div>
						<div style={{ marginTop: "12px" }}> {element.name}</div>
					</td>
				</MediaQuery>
				<td
					style={{
						color: "#FFFFFF",
						fontSize: "70%",
						border: "none",
					}}
				>
					{element.AuthValue}
				</td>
				<td
					style={{
						color: "#FFFFFF",
						fontSize: "100%",
						border: "none",
					}}
				>
					<td
						style={{
							color: "#FFFFFF",
							fontSize: "70%",
							border: "none",
							padding: "0px",
							margin: "0px",
						}}
					>
						{element.AccessLevel}
					</td>
				</td>
			</tr>
		</>
	));
	useEffect(() => {
		getTeamdetails(obj);
	}, []);
	return (
		<>
			<Container style={{ padding: "0px" }} size="100%">
				<Text
					weight={700}
					mt={20}
					mb={10}
					style={{ fontSize: "20px", color: "#FFFFFF" }}
				>
					Team Management
				</Text>
				<div style={{ overflowX: "auto" }}>
					<Table>
						<thead
							style={{
								background: "#1F4A88",
								color: "#FFFFFF",
							}}
						>
							<tr>
								<th
									style={{
										color: "#FFFFFF",
										fontSize: "70%",
										borderBottom: "none",
										borderTopLeftRadius: "5px",
										borderBottomLeftRadius: "5px",
									}}
								>
									Name
								</th>
								<th
									style={{
										color: "#FFFFFF",
										fontSize: "70%",
										borderBottom: "none",
									}}
								>
									Email
								</th>
								<th
									style={{
										color: "#FFFFFF",
										fontSize: "70%",
										borderBottom: "none",
									}}
								>
									Access Level
								</th>
								<th
									style={{
										fontSize: "1.2vw",
										borderBottom: "none",
										borderTopRightRadius: "5px",
										borderBottomRightRadius: "5px",
									}}
								></th>
							</tr>
						</thead>
						<tbody>{ownerRow}</tbody>
						<tbody>{rows}</tbody>
					</Table>
				</div>
			</Container>
		</>
	);
};

export default TeamManagement;
